export default "__VITE_ASSET__Vtm6HYQI__"